import { eraOptions, genreOptions, ratingOptions } from "@/mocks/categories";

interface FilterPanelProps {
  selectedGenres: string[];
  selectedEras: string[];
  selectedRatings: string[];
  onToggleGenre: (value: string) => void;
  onToggleEra: (value: string) => void;
  onToggleRating: (value: string) => void;
  onClear: () => void;
}

interface PillProps {
  active: boolean;
  label: string;
  onClick: () => void;
}

function FilterPill({ active, label, onClick }: PillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-sm transition-colors cursor-pointer ${
        active
          ? "border-primary-500 bg-primary-500 text-background-50"
          : "border-background-300/70 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
      }`}
    >
      {label}
    </button>
  );
}

export default function FilterPanel({
  selectedGenres,
  selectedEras,
  selectedRatings,
  onToggleGenre,
  onToggleEra,
  onToggleRating,
  onClear,
}: FilterPanelProps) {
  const hasFilter =
    selectedGenres.length > 0 ||
    selectedEras.length > 0 ||
    selectedRatings.length > 0;

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-semibold text-foreground-950">
          筛选条件
        </h3>
        {hasFilter && (
          <button
            type="button"
            onClick={onClear}
            className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-accent-600 transition-colors hover:text-accent-700 cursor-pointer"
          >
            <i className="ri-refresh-line text-sm"></i>
            清除
          </button>
        )}
      </div>

      <div className="mt-5">
        <p className="text-xs font-medium tracking-wide text-foreground-600">类型</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {genreOptions.map((genre) => (
            <FilterPill
              key={genre}
              label={genre}
              active={selectedGenres.includes(genre)}
              onClick={() => onToggleGenre(genre)}
            />
          ))}
        </div>
      </div>

      <div className="mt-6">
        <p className="text-xs font-medium tracking-wide text-foreground-600">年代</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {eraOptions.map((era) => (
            <FilterPill
              key={era.key}
              label={era.label}
              active={selectedEras.includes(era.key)}
              onClick={() => onToggleEra(era.key)}
            />
          ))}
        </div>
      </div>

      <div className="mt-6">
        <p className="text-xs font-medium tracking-wide text-foreground-600">评分</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {ratingOptions.map((rating) => (
            <FilterPill
              key={rating.key}
              label={rating.label}
              active={selectedRatings.includes(rating.key)}
              onClick={() => onToggleRating(rating.key)}
            />
          ))}
        </div>
      </div>

      <p className="mt-6 text-xs leading-relaxed text-foreground-500">
        筛选条件可多选，勾选后列表将自动刷新。
      </p>
    </div>
  );
}